import { render } from "./FooterMenu.vue?vue&type=template&id=27cb5872&ts=true"
import script from "./FooterMenu.vue?vue&type=script&lang=ts"
export * from "./FooterMenu.vue?vue&type=script&lang=ts"

import "./FooterMenu.vue?vue&type=style&index=0&id=27cb5872&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__